import {Injectable} from '@angular/core';
import { ODataEntitySetService, ODataServiceFactory } from 'angular-odata';
import {SupplierScope, SupplierScopeExistence, SupplierScopeRequest} from '../../models/supplier-scope';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {SQDataConfiguration} from '../table/configuration/OData-configuration';

@Injectable()
export class SupplierScopeService {
  private odata: ODataEntitySetService<SupplierScope>;
  private readonly config: SQDataConfiguration;

  constructor(public odataFactory: ODataServiceFactory, public http: HttpClient) {
    this.odata = this.odataFactory.entitySet<SupplierScope>('SupplierScope');
    this.config = new SQDataConfiguration();
  }

  public getProcesses(): Observable<any[]> {
    return this.http.get<any[]>(this.config.apiBaseUrl + 'SupplierScopeProcess');
  }
  public getSupplierScope(id: number): Observable<SupplierScope> {
    return this.http.get<SupplierScope>(this.config.apiBaseUrl + 'SupplierScope/' + id);
  }
  public validateSupplierScopeExistence(supplierId: number, scopeId: number, technology) {
    return this.http.get<SupplierScopeExistence>(this.config.apiBaseUrl + `SupplierScope/Supplier/${supplierId}/Scope/${scopeId}/Technology/${technology}`);
  }
  public linkSupplierToScope(supplierInfo: SupplierScope, technology: string) {
    return this.http.post(this.config.apiBaseUrl + 'SupplierScope/Add()', supplierInfo, {params: {technology: technology}});
  }

  public unlinkSupplierToScope(supplierScopeId: number) {
    return this.http.delete(this.config.apiBaseUrl + 'SupplierScope/' + supplierScopeId);
  }

  public updateSupplierScope(supplierScope: SupplierScopeRequest, technology: string) {
    return this.http.post<SupplierScope>(this.config.apiBaseUrl + 'SupplierScope/Update(' + supplierScope.Id + ')', supplierScope, {params: {technology: technology}});
  }

  public deleteSupplierScope(supplierScopeId: number) {
    return this.http.delete(this.config.apiBaseUrl + 'SupplierScope/' + supplierScopeId);
  }

  public bulkUpdateDerivatives(data: { SupplierScopeId: number, DerivativeIds: Array<number> }) {
    return this.http.post<SupplierScope>(this.config.apiBaseUrl + 'SupplierScopeDerivative', data);
  }
}
